import axios from "axios";
class UploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(uploadedFile => {
            return new Promise((resolve, reject) => {
                const data = new FormData();
                data.append("upload", uploadedFile);

                axios({
                    url: "/third-party/upload-image",
                    method: "post",
                    data,
                    headers: {
                        "Content-Type": "multipart/form-data;"
                    },
                    withCredentials: false
                })
                    .then(response => {
                        if (response.data.code == 200) {
                            resolve({
                                default: response.data.data.default
                            });
                        } else {
                            reject(response.data.message);
                        }
                    })
                    .catch(response => {
                        reject("Upload failed");
                    });
            });
        });
    }

    abort() { }
}
export const mixInCkeditor = {
    data() {
        return {
            editorConfig: {
                extraPlugins: [this.MyCustomUploadAdapterPlugin],
                heading: {
                    options: [
                        {
                            model: "paragraph",
                            title: "Paragraph",
                            class: "ck-heading_paragraph"
                        },
                        {
                            model: "heading1",
                            view: "h1",
                            title: "Heading 1",
                            class: "ck-heading_heading1"
                        },
                        {
                            model: "heading2",
                            view: "h2",
                            title: "Heading 2",
                            class: "ck-heading_heading2"
                        },
                        {
                            model: "heading3",
                            view: "h3",
                            title: "Heading 3",
                            class: "ck-heading_heading3"
                        },
                        {
                            model: "heading4",
                            view: "h4",
                            title: "Heading 4",
                            class: "ck-heading_heading4"
                        },
                        {
                            model: "heading5",
                            view: "h5",
                            title: "Heading 5",
                            class: "ck-heading_heading5"
                        },
                        {
                            model: "heading6",
                            view: "h6",
                            title: "Heading 6",
                            class: "ck-heading_heading6"
                        }
                    ]
                }
            },
        }
    },
    methods: {
        MyCustomUploadAdapterPlugin(editor) {
            editor.plugins.get("FileRepository").createUploadAdapter = loader => {
                return new UploadAdapter(loader);
            };
        },
    }

}